import { useStaf } from '../../../Context/StafContext';
import DataTableTitle from '../../DataTableComponents/DataTableTitle';
import { Button } from 'reactstrap';
// import postSlipGaji from '../services/postSlipGaji';

const SlipGajiColumns = () => {
  const stafAPI = useStaf();
  const handleCetakSlipGaji = (data) => {
    stafAPI.postSlipGaji(data);
  };

  return [
    {
      name: <DataTableTitle text="No. Urut" />,
      selector: (row) => row?.no,
      sortable: true,
    },
    {
      name: <DataTableTitle text="Email" />,
      selector: (row) => row?.email,
      sortable: true,
    },
    {
      name: <DataTableTitle text="Nama" />,
      selector: (row) => row?.nama,
      sortable: true,
    },
    {
      name: <DataTableTitle text="Operasi" />,
      cell: (row) => (
        <Button
          type="button"
          color="success"
          style={{ minWidth: '200px' }}
          onClick={() => handleCetakSlipGaji(row)}
        >
          Cetak
        </Button>
      ),
    },
  ];
};

export default SlipGajiColumns;